import React from 'react';
import { Link } from 'react-router-dom';
export const SiteFooter = () => {
  return <footer className="bg-[#1a2e4a] border-t-[3px] border-[#e8c84a] mt-[20px]" data-id="element-141">
      <div className="max-w-[900px] mx-auto px-[20px] py-[24px] flex flex-col gap-[10px]" data-id="element-142">
        <div className="text-[16px] font-extrabold text-white" data-id="element-143">
          Vi<span className="text-[#e8c84a]" data-id="element-144">We</span> Forum
        </div>
        <div className="flex gap-[20px] flex-wrap" data-id="element-145">
          <Link to="/impressum" className="text-[12px] text-[#8da4bc] no-underline hover:text-white" data-id="element-146">
            Impressum
          </Link>
          <Link to="/datenschutz" className="text-[12px] text-[#8da4bc] no-underline hover:text-white" data-id="element-147">
            Datenschutz
          </Link>
          <Link to="/nutzungsbedingungen" className="text-[12px] text-[#8da4bc] no-underline hover:text-white" data-id="element-148">
            Nutzungsbedingungen
          </Link>
          <Link to="/kontakt" className="text-[12px] text-[#8da4bc] no-underline hover:text-white" data-id="element-149">
            Kontakt
          </Link>
        </div>
        <div className="text-[11px] text-[#6a7f96]" data-id="element-150">
          © 2026 ViWe Forum – Vital-Wegweiser. Alle Rechte vorbehalten.
        </div>
        <div className="text-[10px] text-[#4a5f74] max-w-[600px] leading-[1.5]" data-id="element-151">
          Die Inhalte dieses Forums dienen ausschließlich der allgemeinen
          Information und ersetzen keine medizinische Beratung.
        </div>
      </div>
    </footer>;
};